"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "feilmeldingerForRedigerteKortISkattemelding", {
    enumerable: true,
    get: function() {
        return feilmeldingerForRedigerteKortISkattemelding;
    }
});
var _get = /*#__PURE__*/ _interop_require_default(require("lodash/get"));
var _index = require("../utils/index");
var _valideringsregler = require("./valideringsregler");
var _feilmeldingerForKortType = require("./feilmeldingerForKortType");
var _feilmeldingerForFeltMedAlleValideringsregler = /*#__PURE__*/ _interop_require_default(require("./feilmeldingerForFeltMedAlleValideringsregler"));
var _kortUtils = require("../kort/kortUtils");
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function hentForekomstArray(data, korttypeKey) {
    var forekomst = data[korttypeKey];
    if (!forekomst) {
        return [];
    }
    if (Array.isArray(forekomst)) {
        return forekomst;
    }
    return hentForekomstArray(forekomst, Object.keys(forekomst)[0]);
}
function leggTilPotensiellKobletForekomst(korttype, forekomst, data) {
    if (korttype.forekomstKobling) {
        var kobletData = (0, _get.default)(data, korttype.forekomstKobling.referanse);
        var koblingsreferanse = korttype.forekomstKobling.koblingsreferanse;
        var koblingsId = forekomst[koblingsreferanse];
        var kobletForekomst = kobletData.find(function(potensiellKobletForekomst) {
            return potensiellKobletForekomst.id === koblingsId || potensiellKobletForekomst[koblingsreferanse] === koblingsId;
        });
        return _object_spread({}, forekomst, kobletForekomst);
    }
    return forekomst;
}
var feilmeldingerForKortTypeMedRegler = (0, _feilmeldingerForKortType.feilmeldingerForKortType)((0, _feilmeldingerForFeltMedAlleValideringsregler.default)());
var feilmeldingerForRedigerteKortISkattemelding = function(_feilmeldingerForFelt) {
    return function(redigert, data, visningsdefinisjon, valideringsstate) {
        var resultat = [];
        Object.entries(redigert).forEach(function(param) {
            var _param = _sliced_to_array(param, 2), korttypeReferanse = _param[0], redigertForekomstArray = _param[1];
            if (!Array.isArray(redigertForekomstArray)) {
                return;
            }
            var korttype = (0, _index.finnKorttypedefinisjon)(korttypeReferanse, visningsdefinisjon);
            if (!korttype || (0, _kortUtils.kortSkalSkjules)(korttype, [], {}, {}, data)) {
                return;
            }
            redigertForekomstArray.forEach(function(redigertForekomst) {
                hentForekomstArray(data, korttypeReferanse).forEach(function(forekomst) {
                    if (forekomst.id === redigertForekomst.id) {
                        var forekomstMedKobletForekomstOgSkatteplikt = _object_spread_props(_object_spread({}, leggTilPotensiellKobletForekomst(korttype, forekomst, data)), {
                            skatteplikt: data.skatteplikt
                        });
                        var kortHarFeilmeldinger = false;
                        var feilmeldingerForKort = {};
                        var valideringForKort = _object_spread({}, validerOpplysningerOverfoertFraBarn(korttype, forekomst), feilmeldingerForKortTypeMedRegler(korttype, forekomstMedKobletForekomstOgSkatteplikt, valideringsstate, forekomstMedKobletForekomstOgSkatteplikt, data));
                        Object.entries(valideringForKort).forEach(function(param) {
                            var _param = _sliced_to_array(param, 2), feltId = _param[0], feilmeldinger = _param[1];
                            if (feilmeldinger.length > 0) {
                                kortHarFeilmeldinger = true;
                                feilmeldingerForKort[feltId] = feilmeldinger;
                            }
                        });
                        if (kortHarFeilmeldinger) {
                            resultat.push({
                                korttypeid: korttype.id,
                                forekomstid: forekomst.id,
                                feilmeldinger: feilmeldingerForKort
                            });
                        }
                    }
                });
            });
        });
        return resultat;
    };
};
var obligatoriskeFeltForOverfoertFraBarn = [
    "overfoertFraFornavn",
    "overfoertFraEtternavn",
    "overfoertFraFoedselsnummer"
];
function validerOpplysningerOverfoertFraBarn(korttype, forekomst) {
    var feilmeldinger = {};
    if (korttype.overfoeringFraBarnTilForeldre && forekomst["overfoertFra"] === "barn") {
        obligatoriskeFeltForOverfoertFraBarn.forEach(function(referanse) {
            if (!_valideringsregler.obligatorisk.valider(forekomst[referanse])) {
                feilmeldinger["overfoertMellomParter.".concat(referanse)] = [
                    {
                        args: {},
                        feilmelding: _valideringsregler.obligatorisk.feilmelding
                    }
                ];
            }
            if (referanse === "overfoertFraFoedselsnummer" && !_valideringsregler.fnr.valider(forekomst[referanse])) {
                feilmeldinger["overfoertMellomParter.".concat(referanse)] = [
                    {
                        args: {},
                        feilmelding: _valideringsregler.fnr.feilmelding
                    }
                ];
            }
        });
    }
    return feilmeldinger;
}
